import { Box, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function ModalComponent({
  open,
  onClose,
  width = "90vw",
  title,
  children,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: width,
          maxWidth: 1400,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={3}
          py={2}
          borderBottom={`1px solid ${themeColorsDesingSystem.stone.main}`}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: themeColorsDesingSystem.primary.main,
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label="fechar" size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 3,
            py: 2,
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
}
